import p1 from "./photo-1.jpg";
import p2 from "./photo-2.jpg";
import p3 from "./photo-3.jpg";
import p4 from "./photo-4.jpg";
import p5 from "./photo-5.jpg";
import p6 from "./photo-6.jpg";
import p7 from "./photo-7.jpg";
import p8 from "./photo-8.jpg";
import p9 from "./photo-9.jpg";
import p10 from "./photo-10.jpg";
import p11 from "./photo-11.jpg";
import p12 from "./photo-12.jpg";
import p13 from "./photo-13.jpg";
import p14 from "./photo-14.jpg";
import p15 from "./photo-15.jpg";
import p16 from "./photo-16.jpg";
import p17 from "./photo-17.jpg";
import p18 from "./photo-18.jpg";
import p19 from "./photo-19.jpg";
import p20 from "./photo-20.jpg";
import p21 from "./photo-21.jpg";
import p22 from "./photo-22.jpg";
import p23 from "./photo-23.jpg";
import p24 from "./photo-24.jpg";
import p25 from "./photo-25.jpg";
import p26 from "./photo-26.jpg";
import p27 from "./photo-27.jpg";
import p28 from "./photo-28.jpg";
import p29 from "./photo-29.jpg";
import p30 from "./photo-30.jpg";
import p31 from "./photo-31.jpg";
import p32 from "./photo-32.jpg";
import p33 from "./photo-33.jpg";
import p34 from "./photo-34.jpg";
import p35 from "./photo-35.jpg";
import p36 from "./photo-36.jpg";
import p37 from "./photo-37.jpg";
import p38 from "./photo-38.jpg";
import p39 from "./photo-39.jpg";
import p40 from "./photo-40.jpg";
import p41 from "./photo-41.jpg";
import p42 from "./photo-42.jpg";
import p43 from "./photo-43.jpg";
import p44 from "./photo-44.jpg";
import p45 from "./photo-45.jpg";
import p46 from "./photo-46.jpg";
import p47 from "./photo-47.jpg";
import p48 from "./photo-48.jpg";
import p49 from "./photo-49.jpg";
import p50 from "./photo-50.jpg";
import p51 from "./photo-51.jpg";
import p52 from "./photo-52.jpg";

export const kolovratyMirovaImages = [
  p1,
  p2,
  p3,
  p4,
  p5,
  p6,
  p7,
  p10,
  p11,
  p12,
  p13,
  p14,
  p15,
  p16,
  p17,
  p18,
  p19,
  p20,
  p21,
  p22,
  p23,
  p26,
  p27,
  p28,
  p29,
  p30,
  p31,
  p32,
  p33,
  p34,
  p35,
  p36,
  p37,
  p38,
  p39,
  p40,
  p41,
  p42,
  p43,
  p44,
  p45,
  p46,
  p47,
  p48,
  p49,
  p50,
  p51,
  p52,
];

export const kolovratyMirovaFloorPlans = [
  { image: p8, label: "Půdorys 1" },
  { image: p9, label: "Půdorys 2" },
  { image: p24, label: "Půdorys 3" },
  { image: p25, label: "Půdorys 4" },
];
